<template>
    <woot-modal :show.sync="show" :on-close="onClose">
        <div class="column content-box">
            <woot-modal-header 
                :header-title="$t('INTEGRATION_APPS.FIPE.EDIT.TITLE')" 
                :header-content="$t('INTEGRATION_APPS.FIPE.EDIT.DESC')"
            />

            <form class="row" @submit.prevent="editFipe()">
                <div class="medium-12 columns">
                    <label :class="{ error: $v.price.$error }">
                        {{ $t('INTEGRATION_APPS.FIPE.EDIT.FORM.PRICE.LABEL') }}
                        <input 
                            v-model.trim="price" 
                            type="text"
                            @keypress="validateNumberInput" 
                            step="any" 
                            :placeholder="$t('INTEGRATION_APPS.FIPE.EDIT.FORM.PRICE.PLACEHOLDER')" 
                            @input="$v.price.$touch" 
                        />
                    </label>
                </div>
                <div class="medium-12 columns">
                    <label :class="{ error: $v.fipeMin.$error }">
                        {{ $t('INTEGRATION_APPS.FIPE.EDIT.FORM.FIPE_MIN.LABEL') }}
                        <input 
                            v-model.trim="fipeMin" 
                            type="text"
                            @keypress="validateNumberInput"
                            step="any"  
                            :placeholder="$t('INTEGRATION_APPS.FIPE.EDIT.FORM.FIPE_MIN.PLACEHOLDER')" 
                            @input="$v.fipeMin.$touch" 
                        />
                    </label>
                </div>
                <div class="medium-12 columns">
                    <label :class="{ error: $v.fipeMax.$error }">
                        {{ $t('INTEGRATION_APPS.FIPE.EDIT.FORM.FIPE_MAX.LABEL') }}
                        <input 
                            v-model.trim="fipeMax" 
                            type="text"
                            @keypress="validateNumberInput"
                            step="any"  
                            :placeholder="$t('INTEGRATION_APPS.FIPE.EDIT.FORM.FIPE_MAX.PLACEHOLDER')" 
                            @input="$v.fipeMax.$touch" 
                        />
                    </label>
                </div>

                <div class="modal-footer">
                    <div class="medium-12 columns">
                        <woot-submit-button 
                            :disabled="isFormInvalid" 
                            :button-text="$t('INTEGRATION_APPS.FIPE.EDIT.FORM.SUBMIT')" 
                            :loading="editFipeLoading" 
                            class="bg-primary" 
                        />
                        <button class="button clear" @click.prevent="onClose">
                            {{ $t('INTEGRATION_APPS.FIPE.EDIT.CANCEL_BUTTON_TEXT') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </woot-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
    mixins: [alertMixin],
    props: {
        onClose: {
            type: Function,
            default: () => {},
        },
        integration: {
            type: Object,
            default: () => ({}),
        },
        fipeData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fipeMin: this.fipeData.fipeMinimo || '',
            fipeMax: this.fipeData.fipeMaximo || '',
            price: this.fipeData.preco || '',
            editFipeLoading: false,
            show: true,
        };
    },
    computed: {
        ...mapGetters({
            plans: 'getPlanQuotations',
        }),
        isFormInvalid() {
            return (
                this.$v.fipeMin.$invalid ||
                this.$v.fipeMax.$invalid ||
                this.$v.price.$invalid ||
                this.editFipeLoading
            );
        },
    },
    validations() {
        return {
            fipeMin: {
                required,
                minValue: minValue(0),
            },
            fipeMax: {
                required,
                minValue: minValue(0),
            },
            price: {
                required,
                minValue: minValue(0),
            },
        };
    },
    methods: {
        validateNumberInput(event) {
            const char = String.fromCharCode(event.keyCode);
            const validChars = '0123456789.';
            const inputValue = event.target.value;

            if (!validChars.includes(char)) {
                event.preventDefault();
            }

            if (char === '.' && inputValue.includes('.')) {
                event.preventDefault();
            }
        },

        editFipe() {
            this.editFipeLoading = true;

            const payload = {
                ...this.fipeData,
                fipeMinimo: this.fipeMin,
                fipeMaximo: this.fipeMax,
                preco: this.price,
            };

            this.$store.dispatch('updateFipe', payload)
                .then(() => {
                    this.editFipeLoading = false;
                    this.showAlert(this.$t('INTEGRATION_APPS.FIPE.EDIT.API.SUCCESS_MESSAGE'));
                    this.onClose();
                })
                .catch((error) => {
                    this.editFipeLoading = false;
                    const errorMessage =
                        error?.message || this.$t('INTEGRATION_APPS.FIPE.EDIT.API.ERROR_MESSAGE');
                    this.showAlert(errorMessage);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.modal-footer {
    margin-top: 1rem;
}
</style>